export const CURRENT_USER_QUERY_KEY = ['current-user'] as const;
